module.exports = __webpack_public_path__ + "static/media/directionmarker-right.d3a2139f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/03/assets/directionmarker-right.svg
// module id = 427
// module chunks = 0